import React from "react";

export const defaultcategories = [
  { category: "Permanent Workers", value: "" },
  { category: "Other Than Permanent Workers", value: "" },
  { category: "Permanent Employees", value: "" },
  { category: "Other Than Permanent Employees", value: "" },
];

const ReclaimedProductTable = ({
  reclaimedproductdata,
  setReclaimedProductData,
}) => {
  const handleChange = (index, newValue) => {
    const updated = [...reclaimedproductdata];
    updated[index].value = newValue;
    setReclaimedProductData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={{ ...headerStyle, width: "30%" }}>Category</th>
            <th style={{ ...headerStyle, width: "40%" }}>
              Yes/No(If yes, then give details of the mechanism in brief)
            </th>
          </tr>
        </thead>
        <tbody>
          {reclaimedproductdata.map((row, index) => (
            <tr
              key={row.category}
              style={{
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff",
              }}
            >
              <td
                style={{
                  ...cellStyle,
                  fontWeight: "bold",
                  textAlign: "left",
                  backgroundColor: "#D3C9CE",
                }}
              >
                {row.category}
              </td>
              <td style={{ ...cellStyle, width: "40%" }}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.value}
                  onChange={(e) => handleChange(index, e.target.value)}
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const headerStyle = {
  padding: "12px",
  border: "1px solid #000",
  textAlign: "center",
};

const cellStyle = {
  padding: "14px",
  border: "1px solid #000",
  textAlign: "center",
};

const inputStyle = {
  width: "70%",
  padding: "20px",
  fontSize: "14px",
  border: "1px solid grey",
  borderRadius: "6px",
  textAlign: "center",
  backgroundColor: "white",
  outline: "none",
};

export default ReclaimedProductTable;
